import React from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import SubTitleTemplate from '../../common/template/SubTitleTemplate';

const TechPlanView = ({ tech, techPlan }) => {
  return (
    <Box>
      <SubTitleTemplate title="작업 계획 내역">
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
          >
            <Grid item xs={2}>
              <Typography variant="subtitle2" component="div">작업 계획 제목</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body2" component="div">{techPlan?.plnTitle}</Typography>
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
          >
            <Grid item xs={2}>
              <Typography variant="subtitle2" component="div">작업 계획 종류</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">{techPlan?.plnTyp}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="subtitle2" component="div">계획자</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">{techPlan?.plnNm}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="subtitle2" component="div">작업 계획 기간</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div"> {techPlan?.plnStrtDt}~{techPlan?.plnEndDt}</Typography>
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ py: 1 }}
          >
            <Grid item xs={2}>
              <Typography variant="subtitle2" component="div" >참고사항</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography sx={{ whiteSpace: 'pre-line' }} variant="body2" component="div">{techPlan?.plnContext}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </SubTitleTemplate>

    </Box>
  );
};

export default TechPlanView;
